// ─── Barème de l'achat à la carte ──────────────────────────────────
// `config/pointsALaCarte` — DISTINCT de `config/fonctionnalites` (poids des
// fonctions) et de `config/plans` (points inclus par forfait). Un seul
// barème, PARTAGÉ par tous les forfaits : c'est tout l'intérêt du modèle en
// pool — un prix par PALIER DE POINTS plutôt qu'un prix par fonction.
// Écriture à chaque modification (pas de disquette) : la même grammaire que
// les steppers jetons/espaces d'à côté, pour rester cohérent sur cet écran.
import React, { useEffect, useMemo, useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import { stylesForm, useUI, useT, ecouterBareme, BAREME_DEFAUT } from '@mop/core';
import { definirBareme } from './services/admin';

export default function SectionBareme() {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const [bareme, setBareme] = useState(BAREME_DEFAUT);
  const [err, setErr] = useState('');

  useEffect(() => ecouterBareme(setBareme, (e) => setErr(e?.message || String(e))), []);

  const enregistrer = (next) => { setBareme(next); definirBareme(next).catch(e => setErr(e?.message || String(e))); };
  const majLigne = (i, patch) => enregistrer(bareme.map((b, idx) => (idx === i ? { ...b, ...patch } : b)));
  const ajouter = () => {
    const avantDernier = bareme[bareme.length - 2];
    const nouveauMax = (avantDernier?.max || 0) + 3;
    enregistrer([...bareme.slice(0, -1), { max: nouveauMax, prix: 0 }, bareme[bareme.length - 1]]);
  };
  const retirer = (i) => { if (bareme.length > 1) enregistrer(bareme.filter((_, idx) => idx !== i)); };

  return (
    <View style={s.bloc}>
      <Text style={s.titre}>{t('admin.baremePoints')}</Text>
      <Text style={s.aide}>{t('admin.baremePointsAide')}</Text>
      {!!err && <Text style={s.err}>⚠️ {err}</Text>}
      {bareme.map((b, i) => (
        <View key={i} style={s.ligne}>
          {b.max == null ? (
            <Text style={s.lblAuDela}>{t('admin.baremeAuDela')}</Text>
          ) : (
            <View style={s.champ}>
              <Text style={s.lbl}>{t('admin.jusqua')}</Text>
              <TextInput style={s.input} keyboardType="numeric" value={String(b.max)}
                onChangeText={(v) => majLigne(i, { max: Math.max(1, parseInt(v, 10) || 1) })} />
              <Text style={s.lbl}>{t('admin.pts')}</Text>
            </View>
          )}
          <View style={s.champ}>
            <TextInput style={s.input} keyboardType="decimal-pad" value={String(b.prix)}
              onChangeText={(v) => majLigne(i, { prix: parseFloat(v.replace(',', '.')) || 0 })} />
            <Text style={s.lbl}>€/mois</Text>
          </View>
          {bareme.length > 1 && (
            <TouchableOpacity hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }} onPress={() => retirer(i)}>
              <Text style={s.retirer}>✕</Text>
            </TouchableOpacity>
          )}
        </View>
      ))}
      <TouchableOpacity style={s.ajouter} onPress={ajouter}>
        <Text style={s.ajouterTxt}>＋ {t('admin.ajouterPalier')}</Text>
      </TouchableOpacity>
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  ...stylesForm(UI),
  bloc: { backgroundColor: UI.card, borderRadius: 13, borderWidth: 0.5, borderColor: UI.border, padding: 12, marginBottom: 8, gap: 6 },
  titre: { fontSize: 14.5, fontWeight: '800', color: UI.ink },
  aide: { fontSize: 11.5, color: UI.muted },
  err: { fontSize: 12.5, color: UI.danger, fontWeight: '700' },
  ligne: { flexDirection: 'row', alignItems: 'center', gap: 8, paddingVertical: 6, borderTopWidth: 0.5, borderTopColor: UI.border },
  champ: { flexDirection: 'row', alignItems: 'center', gap: 5 },
  lbl: { fontSize: 12, color: UI.muted, fontWeight: '600' },
  lblAuDela: { fontSize: 12.5, fontWeight: '700', color: UI.ink, minWidth: 90 },
  input: { backgroundColor: UI.champ, borderRadius: 8, paddingHorizontal: 8, paddingVertical: 6,
           fontSize: 13, color: UI.ink, borderWidth: 0.5, borderColor: UI.champBord, width: 54, textAlign: 'center' },
  retirer: { fontSize: 13, color: UI.faint, marginLeft: 'auto' },
  ajouter: { marginTop: 6, alignItems: 'center', paddingVertical: 8, borderRadius: 9, borderWidth: 1, borderColor: UI.accent, borderStyle: 'dashed' },
  ajouterTxt: { color: UI.accent, fontWeight: '700', fontSize: 12.5 },
});
